import { createApiSlice } from "@common";
import {
  CURD_CONSENT_SOURCE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addConsentSource",
    method: "post",
    url: CURD_CONSENT_SOURCE,
    stateKey: "message",
  },
  {
    name: "getConsentSource",
    method: "get",
    url: CURD_CONSENT_SOURCE,
    stateKey: "data",
  },
  {
    name: "updateConsentSource",
    method: "put",
    url: CURD_CONSENT_SOURCE,
    stateKey: "message",
  },
  {
    name: "deleteConsentSource",
    method: "delete",
    url: CURD_CONSENT_SOURCE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "consentSource",
  apiConfig,
  customReducers,
);
const consentSourceSlice = slice;
// Export the slice's reducer
export default consentSourceSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addConsentSource,
  getConsentSource,
  updateConsentSource,
  deleteConsentSource
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
